import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, PaymentsReceipt, ReceiptSummary, ReceiptCAFooterNote, ReceiptBillingAddress, ReceiptTotalTitle } from '..';
import { AppRoutes } from '../../routes';
import { LanguageCodes } from '../../types/preference.type';
import { Receipt } from 'guest-data-types-ts-lib';
import { Reservation, Stay, Unit, RequiredActions, Guests } from 'guest-data-types-ts-lib';
import { TranslationUtils } from '../../utils';
import './ReceiptMor.scss';
import { ReceiptLineSummary } from './ReceiptLineSummary';

interface ReceiptProps {
    reservation: Reservation;
    guests: Guests;
    stay: Stay;
    receipt: Receipt;
    requiredActions: RequiredActions;
    unit: Unit;
    locale: LanguageCodes;
}

export const ReceiptMor: React.FC<ReceiptProps> = (props) => {
    const { reservation, guests, receipt, requiredActions, unit, locale, stay } = props;
    const { payments, summary, converted_summary, trip_protection, trip_protection_text, consumer_protection_bc } = receipt;
    const isPaymentComplete =
        requiredActions.pay_balance && requiredActions.pay_balance.completed && +requiredActions.pay_balance.balance_due <= 0;
    const history = useHistory();
    return (
        <div id="receipt-trip">
            <div id="panel-totals" className="col-md-12 cost-breakdown-receipt">
                <div tabIndex={0}>
                    {reservation.reservation_source_type === '3rd Party Channel Reservation' && (
                        <h5 className={'body-regular'}>
                            {TranslationUtils.get('receipt_thirty_party_channel', { channel: reservation.channel })}
                        </h5>
                    )}
                </div>
                <br />
                <ReceiptTotalTitle summary={summary} convertedSummary={converted_summary || undefined} locale={locale} />
            </div>

            <div id="panel-summary" className="col-md-12 cost-breakdown-receipt">
                {/* Summary */}
                <div className="m-3">
                    <ReceiptSummary
                        summary={summary}
                        trip_protection={trip_protection}
                        trip_protection_text={trip_protection_text}
                        locale={locale}
                        checkInDateTime={stay.check_in_date_time}
                        checkOutDateTime={stay.check_out_date_time}
                    />
                </div>

                {/* Payments */}
                {payments.length > 0 && <hr />}
                {payments.length > 0 && unit.state === 'BC' ? (
                    <div>
                        <ReceiptBillingAddress guests={guests} consumer_protection_bc={consumer_protection_bc} />
                    </div>
                ) : null}

                <PaymentsReceipt currency={summary.currency} payments={payments} locale={locale} />

                {/* Balance */}
                <div id="panel-balance" className="total-receipt-balance">
                    <ReceiptLineSummary
                        summaryTitle={TranslationUtils.get('balance_in', { currency: summary.currency })}
                        summaryValue={summary.balance}
                        currency={summary.currency}
                        locale={locale}
                    />
                </div>
                <div id="panel-buttons" className="total-receipt-detail">
                    <div className="col-sm-12 text-right">
                        {!isPaymentComplete && (
                            <Button
                                id="button-make-payment"
                                variant="primary"
                                className={'body-regular'}
                                label={TranslationUtils.get('pay_balance')}
                                onClick={() => history.push(AppRoutes.PAYMENT)}
                            />
                        )}
                    </div>
                </div>

                {unit.state === 'BC' && <ReceiptCAFooterNote consumer_protection_bc={consumer_protection_bc} />}
            </div>
        </div>
    );
};
